// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Severity of an incident
 * @export
 */
export const IncidentSeverity = {
    Notice: 'NOTICE',
    Info: 'INFO',
    Warning: 'WARNING',
    Alert: 'ALERT',
    Error: 'ERROR'
} as const;
export type IncidentSeverity = typeof IncidentSeverity[keyof typeof IncidentSeverity];


export function instanceOfIncidentSeverity(value: any): boolean {
    for (const key in IncidentSeverity) {
        if (Object.prototype.hasOwnProperty.call(IncidentSeverity, key)) {
            if (IncidentSeverity[key as keyof typeof IncidentSeverity] === value) {
                return true;
            }
        }
    }
    return false;
}

export function IncidentSeverityFromJSON(json: any): IncidentSeverity {
    return IncidentSeverityFromJSONTyped(json, false);
}

export function IncidentSeverityFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentSeverity {
    return json as IncidentSeverity;
}

export function IncidentSeverityToJSON(value?: IncidentSeverity | null): any {
    return value as any;
}

export function IncidentSeverityToJSONTyped(value: any, ignoreDiscriminator: boolean): IncidentSeverity {
    return value as IncidentSeverity;
}

